import localforage from 'localforage';
import { FC, useContext, useEffect } from 'react';
import ContinueButton from '../components/carousel/ContinueButton';
import './AdviceScreen.scss';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../context/Context';
import { IAppContext } from '../types';
import PATH_ROUTES from '../static/constants/path-routes';
import { BRAND, AdviceMsg } from '../static/constants/brands/brand';
import i18n from '../utils/i18n';
import { savePreInspection } from 'src/services/preInspect.service';

const AdviceScreen: FC = () => {
  const history = useHistory();
  const { state, dispatch } = useContext(AppContext) as IAppContext;


  const openForm = async () => {
    const currentId: any = await localforage.getItem('preId');
    if (currentId && String(currentId).length > 0) {
      savePreInspection(state.formData, state, dispatch, false);        
      history.push(PATH_ROUTES.PRE_TAB_SECTIONS);
    }
  };

  const handleContinue = async () => {
    await openForm();
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="advice"> 
        <div className="advice__intro">
          <h1>{i18n.get('advice.title', 'Guía de Pre-inspección')}</h1>      
          <p
            dangerouslySetInnerHTML={{
              __html: i18n.get(
                'advice.subtitle',    
                'Seguí estas recomendaciones para evitar demoras y validar tu información de forma rápida y sin errores:',
              ),
            }}
          ></p>
          
          {AdviceMsg[BRAND]?.items.map((item, index) => (
            <div key={item.key} className="advice__card advice__card--horizontal">
              <div className="avatar-section">
                <img src={item.icon} alt={`Paso ${index + 1}`} />
              </div>
              <div className="advice__card__content">
                    <h1>{i18n.get(`advice.recommendations.${item.key}.title`, `Titulo de la recomendación`)}</h1>
                <p
                  dangerouslySetInnerHTML={{
                    __html: i18n.get(`advice.recommendations.${item.key}.label`, 'Descripción de la recomendación')
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        
        <ContinueButton onClick={handleContinue}>
          {i18n.get('buttons.guideContinue', 'Continuar')}
        </ContinueButton>
      </div>
    </>
  );
};

export default AdviceScreen;
